export default {
  selectedUnits: [],
  centerAll: false,
  clustering: true,
  panToUnit: null
}